import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import styles from './webDealSubmission.module.scss';
import { IconWrapper } from '../../../common/IconWrapper';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import AuthContext from '../../../authentication/AuthContext';
import axios from 'axios';
import UserContext from '../../../user/UserContext';
import { useAlert } from 'react-alert';
import LoadingSpinner from '../../../common/LoadingSpinner';

export default function WebDealSubmission({ webDealHeaderId, getWebDealLines, submitReady }) {
    const cas = useContext(AuthContext);
    const { userDetails } = useContext(UserContext);
    const [submissionAvailable, setSubmissionAvailable] = useState(submitReady);
    const [maintenanceMessage, setMaintenanceMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const alert = useAlert();

    useEffect(() => {
        axios
            .get(window.CONFIG['ws.activoc-web-order-api.maintenance.status'], {
                headers: {
                    Authorization: cas,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                setMaintenanceMessage(response.data.maintenanceMessage);
                setSubmissionAvailable(false);
            })
            .catch(error => {
                if (error.response?.status === 404) {
                    setSubmissionAvailable(submitReady);
                } else {
                    alert.error('ERROR: Unable to load submission availability status.');
                }
            });
        // eslint-disable-next-line
    }, [cas]);

    useEffect(() => setSubmissionAvailable(submitReady), [submitReady]);

    const submitOrder = () => {
        setLoading(true);
        axios
            .put(
                window.CONFIG['ws.activoc-web-deals-public.order.submit'],
                {
                    franchiseCode: userDetails.currentFranchise.code,
                    webDealHeaderId: webDealHeaderId
                },
                {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then(() => {
                getWebDealLines();
                alert.success('Deal submitted successfully.');
                setLoading(false);
            })
            .catch(() => {
                alert.error('ERROR: Unable to submit order.');
                setLoading(false);
            });
    };

    return (
        <div className={`${styles.webDealSubmission}`}>
            {!submissionAvailable && maintenanceMessage !== '' && (
                <div className={styles.orderSubmissionMessage}>{maintenanceMessage}</div>
            )}
            <Button onClick={submitOrder} className={'btn-action'} disabled={!submissionAvailable || loading}>
                {loading ? (
                    <LoadingSpinner message={'Submitting'} />
                ) : (
                    <>
                        Submit <IconWrapper icon={faChevronRight} />
                    </>
                )}
            </Button>
        </div>
    );
}
